import React, { PureComponent } from "react";
import FieldContainer from "../components/FieldContainer";
import DatePicker from "react-datepicker";
import moment from "moment";
import "react-datepicker/dist/react-datepicker.css";

export default class DateField extends PureComponent {
  render() {
    const { onChange, name, value, showTimeSelect = false, showTimeSelectOnly = false } = this.props;
    const dateFormat = showTimeSelect ? "DD-MM-YYYY HH:mm": "DD-MM-YYYY"; 
    return (
      <FieldContainer {...this.props}>
        <DatePicker
          className="af-string-field"
          selected={value && moment(value, dateFormat)}
          name={name}
          onChange={date => onChange(name, moment(date).format(dateFormat))}
          showTimeSelect={showTimeSelect}
          showTimeSelectOnly={showTimeSelectOnly}
          timeFormat="HH:mm"
          timeIntervals={10}
          dateFormat={dateFormat}
          timeCaption="time"
        />
      </FieldContainer>
    );
  }
}
